import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateLocationModel,
  DeleteLocationModel,
  EditLocationModel,
  SearchLocationModel,
} from '../../../models/location.model'

@Injectable({
  providedIn: 'root',
})
export class PendingPatientsAlertService {
  private baseUrl = environment.baseUrl
  private resource: string = 'dashboard/gestao'

  constructor(private httpClient: HttpClient) {}

  public getCountryState(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `file/lib/countries_states_ptBR.json`,
    )
  }

  public answerAlert(
    id: number,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/responder-alerta/${id}`,
      model,
    )
  }

  public editLocation(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/update`,
      model,
    )
  }

  public deleteLocation(
    model: DeleteLocationModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public getPendingAlerts(
    filters = ''
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/alertas-pendentes?${filters}`,
    )
  }

  public openChat(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/abrir-conversa/${id}`,
    )
  }
  public contactHealthAgent(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/contatar-tutor/${id}`,
    )
  }

  public listActiveLocation(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/getAtivas`,
    )
  }
  public listActiveLocationByMunicip(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/getAtivas?municipio_id=${id}`,
    )
  }
  public listLocationByMunicip(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/byMunicipio/${id}`,
    )
  }
  public listActiveLocations(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/getAtivas`,
    )
  }
  public searchLocation(
    model: SearchLocationModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public searchLocationCityState(
    // model: SearchLocationModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search/cidade-estado`,
      model,
    )
  }

  public getLocationbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedLocation(
    page: number,
    rows: number = 15,
    model: any,
    // model: SearchLocationModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
